import React, { useState } from "react";
import { Form, Button, Container, Row, Col, Card } from "react-bootstrap";
import { toast } from "react-toastify";
import emLogo from "../../assets/images/EM-NEW-LOGO2.png";
import brandLogo from "../../assets/images/01.png";
import { Link } from "react-router-dom";
import Select from "react-select";

const CandRegOpenLink = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    gender: "",
    maritalStatus: "",
    email: "",
    phone: "",
    dob: "",
    highestQualification: "",
    otherQualification: "",
    experience: "",
    sector: "",
    role: "",
    keySkills: "",
    language: "",
    employer: "",
    designation: "",
    yearsOfExperience: "",
    monthsOfExperience: "",
    currentCTC: "",
    expectedCTC: "",
    registeredDate: "",
    source: "",
    personName: "",
    personContact: "",
    residentialAddress: "",
    residentialCity: "",
    mailingAddress: "",
    mailingCity: "",
  });

  const [files, setFiles] = useState({
    aadhar: null,
    resume: null,
    agreement: null,
    photo: null,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    setFiles((prev) => ({
      ...prev,
      [e.target.name]: e.target.files[0],
    }));
  };

  const handleAddCandidate = async (e) => {
    e.preventDefault();

    const requiredFields = [
      "firstName",
      "lastName",
      "email",
      "phone",
      "dob",
      "highestQualification",
      "experience",
    ];

    for (let field of requiredFields) {
      if (!formData[field]) {
        toast.error(`Please fill out the ${field} field.`);
        return;
      }
    }

    // ✅ File validation (e.g., Aadhar is required)
    if (!files.resume) {
      toast.error("Please upload your Resume file.");
      return;
    }

    const form = new FormData();

    Object.entries(formData).forEach(([key, value]) => {
      form.append(key, value);
    });

    Object.entries(files).forEach(([key, file]) => {
      if (file) {
        form.append(key, file);
      }
    });

    try {
      //const response = await fetch("http://localhost:5000/api/registerCandidate",
      const response = await fetch("https://mantraserp.com/api/registerCandidate",
        {
          method: "POST",
          body: form,
        }
      );

      const result = await response.json();

      if (result?.errorCode === 0) {
        toast.success("You are registered successfully!");

        // Clear form
        setFormData({
          firstName: "",
          lastName: "",
          gender: "",
          maritalStatus: "",
          email: "",
          phone: "",
          dob: "",
          highestQualification: "",
          otherQualification: "",
          experience: "",
          sector: "",
          role: "",
          keySkills: "",
          language: "",
          employer: "",
          designation: "",
          yearsOfExperience: "",
          monthsOfExperience: "",
          currentCTC: "",
          expectedCTC: "",
          registeredDate: "",
          source: "",
          personName: "",
          personContact: "",
          residentialAddress: "",
          residentialCity: "",
          mailingAddress: "",
          mailingCity: "",
        });
        setFiles({
          aadhar: null,
          resume: null,
          agreement: null,
          photo: null,
        });
      } else {
        toast.error(result?.message || "Something went wrong");
      }
    } catch (error) {
      let message = "An unexpected error occurred.";
      if (error.message.includes("phone")) {
        message = "Phone number already registered. Please use another.";
      }
      toast.error(message);
      console.error("Registration Error:", error);
    }
  };

  const sourceOptions = [
    "Activities",
    "Admission Centre",
    "Alumni",
    "Apna App",
    "Coaching's",
    "Dizital Mantras",
    "DM Student",
    "Employee Reference",
    "Employment Mantras",
    "Event",
    "Field Data",
    "Franchise",
    "GMB",
    "Google Ad",
    "Incoming Call",
    "Intern",
    "Job Fair",
    "Just Dial",
    "LinkedIn",
    "Meta Ad",
    "Naukari Portal",
    "Purchased Data",
    "Reference",
    "Schools",
    "Self-Generated",
    "Seminar",
    "Walk-In",
    "Website",
    "Webinar",
    "WhatsApp",
    "WhatsApp Group",
    "WhatsApp Status",
  ];

  const languageOptions = [
    { value: "Hindi", label: "Hindi" },
    { value: "English", label: "English" },
    { value: "Assamese", label: "Assamese" },
    { value: "Bengali", label: "Bengali" },
    { value: "Bodo", label: "Bodo" },
    { value: "Dogri", label: "Dogri" },
    { value: "Gujarati", label: "Gujarati" },
    { value: "Kannada", label: "Kannada" },
    { value: "Kashmiri", label: "Kashmiri" },
    { value: "Konkani", label: "Konkani" },
    { value: "Maithili", label: "Maithili" },
    { value: "Malayalam", label: "Malayalam" },
    { value: "Manipuri", label: "Manipuri" },
    { value: "Marathi", label: "Marathi" },
    { value: "Nepali", label: "Nepali" },
    { value: "Odia", label: "Odia" },
    { value: "Punjabi", label: "Punjabi" },
    { value: "Sanskrit", label: "Sanskrit" },
    { value: "Santali", label: "Santali" },
    { value: "Sindhi", label: "Sindhi" },
    { value: "Tamil", label: "Tamil" },
    { value: "Telugu", label: "Telugu" },
    { value: "Urdu", label: "Urdu" },
  ];

  return (
    <div
      style={{
        backgroundColor: "#FFFDF6",
        minHeight: "100vh",
        padding: "1rem",
      }}
    >
      <Container>
        <div className="d-flex justify-content-center">
          <Card className="mb-3 border-0" style={{ maxWidth: "180px" }}>
            <Card.Body className="p-2 text-center">
              <img
                src={emLogo}
                alt="Employment Mantras Logo"
                className="img-fluid"
                style={{ maxWidth: "150px", height: "auto" }}
              />
            </Card.Body>
          </Card>
        </div>

        <Card className="mt-1">
          <Card.Body>
            <h3 className="mb-4">Candidate Registration Form</h3>
            <Form onSubmit={handleAddCandidate}>
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label className="font-weight-bold">
                      First Name
                    </Form.Label>
                    <Form.Control
                      name="firstName"
                      value={formData.firstName}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label className="font-weight-bold">
                      Last Name
                    </Form.Label>
                    <Form.Control
                      name="lastName"
                      value={formData.lastName}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label className="font-weight-bold">Gender</Form.Label>
                    <Form.Select
                      name="gender"
                      value={formData.gender}
                      onChange={handleChange}
                    >
                      <option value="">Select</option>
                      <option>Male</option>
                      <option>Female</option>
                      <option>Other</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label className="font-weight-bold">
                      Marital Status
                    </Form.Label>
                    <Form.Select
                      name="maritalStatus"
                      value={formData.maritalStatus}
                      onChange={handleChange}
                    >
                      <option value="">Select</option>
                      <option>Single</option>
                      <option>Married</option>
                      <option>Other</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label className="font-weight-bold">Email</Form.Label>
                    <Form.Control
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label className="font-weight-bold">
                      Mobile Number
                    </Form.Label>
                    <Form.Control
                      name="phone"
                      value={formData.phone}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (/^\d{0,10}$/.test(value)) {
                          handleChange(e); // update state only if valid
                        }
                      }}
                      required
                      maxLength={10}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label className="font-weight-bold">
                      Date of Birth
                    </Form.Label>
                    <Form.Control
                      type="date"
                      name="dob"
                      value={formData.dob}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group controlId="highestQualification">
                    <Form.Label className="font-weight-bold">
                      Highest Qualification
                    </Form.Label>
                    <Form.Select
                      value={formData.highestQualification}
                      onChange={(e) =>
                        setFormData({ ...formData, highestQualification: e.target.value })
                      }
                    >
                      <option value="">-- Select Qualification --</option>
                      <option value="Doctrate/PhD">PhD</option>
                      <option value="Masters/Post-Graduation">
                        Post-Graduation
                      </option>
                      <option value="Graduation">Graduation</option>
                      <option value="Diploma">Diploma</option>
                      <option value="12th">12th</option>
                      <option value="10th">10th</option>
                      <option value="Below 10th">Below 10th</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label className="font-weight-bold">
                      Total Experience (in years)
                    </Form.Label>
                    <Form.Select
                      name="experience"
                      value={formData.experience}
                      onChange={handleChange}
                    >
                      <option value="">Select</option>
                      <option value="0">0</option>
                      <option value="0.6">0.6</option>
                      {Array.from({ length: 99 }, (_, i) => i + 1).map(
                        (option) => (
                          <option key={option} value={option}>
                            {option}
                          </option>
                        )
                      )}
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label className="font-weight-bold">
                      Sector / Industry
                    </Form.Label>
                    <Form.Select
                      name="sector"
                      value={formData.sector}
                      onChange={handleChange}
                    >
                      <option value="">Select Sector</option>
                      <option value="Accounts or CA or CS or Taxation">
                        Accounts or CA or CS or Taxation
                      </option>
                      <option value="Adhesives">Adhesives</option>
                      <option value="Agency or Consulting">
                        Agency or Consulting
                      </option>
                      <option value="Agriculture">Agriculture</option>
                      <option value="Any Official">Any Official</option>
                      <option value="Automobile">Automobile</option>
                      <option value="Aviation">Aviation</option>
                      <option value="Banking">Banking</option>
                      <option value="Biotech or R&D or Scientist">
                        Biotech or R&D or Scientist
                      </option>
                      <option value="BPO">BPO</option>
                      <option value="Chemical">Chemical</option>
                      <option value="Distribution & Supply Chain">
                        Distribution & Supply Chain
                      </option>
                      <option value="Education">Education</option>
                      <option value="Energy">Energy</option>
                      <option value="Engineering Projects">
                        Engineering Projects
                      </option>
                      <option value="Entertainment">Entertainment</option>
                      <option value="Export or Import">Export or Import</option>
                      <option value="Finance or Micro Finance">
                        Finance or Micro Finance
                      </option>
                      <option value="Financial Services">
                        Financial Services
                      </option>
                      <option value="FMCG">FMCG</option>
                      <option value="Food">Food</option>
                      <option value="Glass">Glass</option>
                      <option value="Govt. Sector">Govt. Sector</option>
                      <option value="Home Furnishing">Home Furnishing</option>
                      <option value="Hospital or Healthcare">
                        Hospital or Healthcare
                      </option>
                      <option value="Hotels or Restaurants">
                        Hotels or Restaurants
                      </option>
                      <option value="Immigration">Immigration</option>
                      <option value="Insurance">Insurance</option>
                      <option value="IT Hardware">IT Hardware</option>
                      <option value="IT Software">IT Software</option>
                      <option value="Manufacturing">Manufacturing</option>
                      <option value="Media and Advertising">
                        Media and Advertising
                      </option>
                      <option value="Oil & Lubricants">Oil & Lubricants</option>
                      <option value="Online Marketing or Digital Marketing">
                        Online Marketing or Digital Marketing
                      </option>
                      <option value="Paint">Paint</option>
                      <option value="Pharmaceutical">Pharmaceutical</option>
                      <option value="Plastic or Pet">Plastic or Pet</option>
                      <option value="Plywood & Laminates">
                        Plywood & Laminates
                      </option>
                      <option value="Publishing & Printing">
                        Publishing & Printing
                      </option>
                      <option value="Real Estate">Real Estate</option>
                      <option value="Retail">Retail</option>
                      <option value="Technology">Technology</option>
                      <option value="Telecom">Telecom</option>
                      <option value="Transport Logistics">
                        Transport or Logistics
                      </option>
                      <option value="Transport or Tour & Travel">
                        Transport or Tour & Travel
                      </option>
                      <option value="Warehouse or Inventory">
                        Warehouse or Inventory
                      </option>
                      <option value="Other">Other</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label className="font-weight-bold">
                      Role & Specialization
                    </Form.Label>
                    <Form.Select
                      name="role"
                      value={formData.role}
                      onChange={handleChange}
                    >
                      <option value="">Select Role & Specialization</option>
                      <option value="Account Executive">
                        Account Executive
                      </option>
                      <option value="Account Manager">Account Manager</option>
                      <option value="Admission Coordinator">
                        Admission Coordinator
                      </option>
                      <option value="Admin Executive">Admin Executive</option>
                      <option value="Admin Manager">Admin Manager</option>
                      <option value="Area Sales Manager (ASM)">
                        Area Sales Manager (ASM)
                      </option>
                      <option value="Article Assistant">
                        Article Assistant
                      </option>
                      <option value="Assistant Manager">
                        Assistant Manager
                      </option>
                      <option value="Auditor">Auditor</option>
                      <option value="Autocad Engineer">Autocad Engineer</option>
                      <option value="Backend or Back Office Executive or Assistant Executive">
                        Backend or Back Office Executive or Assistant Executive
                      </option>
                      <option value="Banquet Manager">Banquet Manager</option>
                      <option value="Billing Executives">
                        Billing Executives
                      </option>
                      <option value="Block Officer">Block Officer</option>
                      <option value="Boiler Operator">Boiler Operator</option>
                      <option value="Brand Manager">Brand Manager</option>
                      <option value="Business Analyst">Business Analyst</option>
                      <option value="Business Development Executive (BDE)">
                        Business Development Executive (BDE)
                      </option>
                      <option value="Business Development Manager (BDM)">
                        Business Development Manager (BDM)
                      </option>
                      <option value="Cashier">Cashier</option>
                      <option value="Civil Engineer">Civil Engineer</option>
                      <option value="Clinical Assistants">
                        Clinical Assistants
                      </option>
                      <option value="Collection Executives">
                        Collection Executives
                      </option>
                      <option value="Commodity Dealer">Commodity Dealer</option>
                      <option value="Company Secretary">
                        Company Secretary
                      </option>
                      <option value="Computer Operator">
                        Computer Operator
                      </option>
                      <option value="Content Writer">Content Writer</option>
                      <option value="Counsellor">Counsellor</option>
                      <option value="Credit Manager">Credit Manager</option>
                      <option value="Customer Care Executive (CCE)">
                        Customer Care Executive (CCE)
                      </option>
                      <option value="Customer Relationship Officer">
                        Customer Relationship Officer
                      </option>
                      <option value="Data Analyst">Data Analyst</option>
                      <option value="Deputy Manager">Deputy Manager</option>
                      <option value="Digital Marketer">Digital Marketer</option>
                      <option value="Electrical Engineer">
                        Electrical Engineer
                      </option>
                      <option value="Electrician">Electrician</option>
                      <option value="Equity Dealer">Equity Dealer</option>
                      <option value="Export Manager">Export Manager</option>
                      <option value="Fashion Designer">Fashion Designer</option>
                      <option value="Finance Executive">
                        Finance Executive
                      </option>
                      <option value="Finance Officer">Finance Officer</option>
                      <option value="Financial Advisor">
                        Financial Advisor
                      </option>
                      <option value="Food & Beverages Executive">
                        Food & Beverages Executive
                      </option>
                      <option value="Food & Beverages Manager">
                        Food & Beverages Manager
                      </option>
                      <option value="Front Office Executive">
                        Front Office Executive
                      </option>
                      <option value="GM/Unit Head">GM/Unit Head</option>
                      <option value="Graphics Designer">
                        Graphics Designer
                      </option>
                      <option value="Hotel Captain">Hotel Captain</option>
                      <option value="Hotel Manager">Hotel Manager</option>
                      <option value="HR Executive">HR Executive</option>
                      <option value="HR Manager">HR Manager</option>
                      <option value="Inventory Manager">
                        Inventory Manager
                      </option>
                      <option value="IT Security Coordinator">
                        IT Security Coordinator
                      </option>
                      <option value="IT Trainer">IT Trainer</option>
                      <option value="ITI Fitter">ITI Fitter</option>
                      <option value="Lab Technician">Lab Technician</option>
                      <option value="Law Officer">Law Officer</option>
                      <option value="Liasoning Manager">
                        Liasoning Manager
                      </option>
                      <option value="Logistic Manager">Logistic Manager</option>
                      <option value="Machine Operator">Machine Operator</option>
                      <option value="Maintenance Engineer">
                        Maintenance Engineer
                      </option>
                      <option value="Mechanical Engineer">
                        Mechanical Engineer
                      </option>
                      <option value="Medical Representative">
                        Medical Representative
                      </option>
                      <option value="Merchandiser">Merchandiser</option>
                      <option value="MIS Executive">MIS Executive</option>
                      <option value="Networking Manager">
                        Networking Manager
                      </option>
                      <option value="Nurse">Nurse</option>
                      <option value="Operation Manager">
                        Operation Manager
                      </option>
                      <option value="Pathologist">Pathologist</option>
                      <option value="Pharmacist">Pharmacist</option>
                      <option value="Placement Officer">
                        Placement Officer
                      </option>
                      <option value="Plant Planning Manager">
                        Plant Planning Manager
                      </option>
                      <option value="Plant Supervisor">Plant Supervisor</option>
                      <option value="PRO">PRO</option>
                      <option value="Production Manager">
                        Production Manager
                      </option>
                      <option value="Project Manager or Team Leader">
                        Project Manager or Team Leader
                      </option>
                      <option value="Purchase Executive">
                        Purchase Executive
                      </option>
                      <option value="Quality Analyst">Quality Analyst</option>
                      <option value="Quality Control or Process Control">
                        Quality Control or Process Control
                      </option>
                      <option value="Receptionist">Receptionist</option>
                      <option value="Regional Manager">Regional Manager</option>
                      <option value="Restaurant Manager">
                        Restaurant Manager
                      </option>
                      <option value="Safety Officer">Safety Officer</option>
                      <option value="Sales Manager or Marketing Manager">
                        Sales Manager or Marketing Manager
                      </option>
                      <option value="Sales or Marketing Executive">
                        Sales or Marketing Executive
                      </option>
                      <option value="SAP or ERP Developer">
                        SAP or ERP Developer
                      </option>
                      <option value="SEO Executive or Manager">
                        SEO Executive or Manager
                      </option>
                      <option value="Service Delivery Manager">
                        Service Delivery Manager
                      </option>
                      <option value="Site Engineer">Site Engineer</option>
                      <option value="Social Media Marketing">
                        Social Media Marketing
                      </option>
                      <option value="Soft Skill Trainer">
                        Soft Skill Trainer
                      </option>
                      <option value="Software Developer">
                        Software Developer
                      </option>
                      <option value="Store Manager">Store Manager</option>
                      <option value="Supervisor">Supervisor</option>
                      <option value="T&D Manager">T&D Manager</option>
                      <option value="Teacher or Lecturer or Trainer">
                        Teacher or Lecturer or Trainer
                      </option>
                      <option value="Team Leader">Team Leader</option>
                      <option value="Technical Sales">Technical Sales</option>
                      <option value="Telecaller">Telecaller</option>
                      <option value="Video Editor">Video Editor</option>
                      <option value="Vice President">Vice President</option>
                      <option value="Waiter or Steward">
                        Waiter or Steward
                      </option>
                      <option value="Warehouse Manager">
                        Warehouse Manager
                      </option>
                      <option value="Web Designer">Web Designer</option>
                      <option value="Web Developer">Web Developer</option>
                      <option value="Zonal Manager">Zonal Manager</option>
                      <option value="Other">Other</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label className="font-weight-bold">
                      Languages Known
                    </Form.Label>
                    <Select
                      isMulti
                      name="language"
                      options={languageOptions}
                      value={languageOptions.filter((option) =>
                        formData.language?.includes(option.value)
                      )}
                      onChange={(selectedOptions) => {
                        const selectedLanguages = selectedOptions.map(
                          (opt) => opt.value
                        );
                        setFormData({
                          ...formData,
                          language: selectedLanguages,
                        });
                      }}
                      className="basic-multi-select"
                      classNamePrefix="select"
                    />
                  </Form.Group>
                </Col>
                
              </Row>

              <Row>
                
                <Col md={12}>
                  <Form.Group className="mb-3">
                    <Form.Label className="font-weight-bold">
                      Key Skills
                      <br />
                      <small>
                        Add Skills that best define your expertise, for e.g,
                        Direct Marketing, Oracle, Java, etc (Minimum 1, use comma for multiple skills.)
                      </small>
                    </Form.Label>
                    <Form.Control
                      name="keySkills"
                      value={formData.keySkills}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  {/* File uploads */}
                  <Form.Label className=" font-weight-bold">Upload Aadhar</Form.Label>
                  <Form.Control
                    type="file"
                    name="aadhar"
                    onChange={handleFileChange}
                  />
                </Col>
                <Col md={6}>
                <Form.Label className=" font-weight-bold">
                  <span className="text-primary font-weight-bold">
                    {" "}
                    Upload Resume
                  </span>
                  <small> (Supported Formats: doc, docx, pdf, jpg only)</small>
                </Form.Label>
                <Form.Control
                  type="file"
                  name="resume"
                  onChange={handleFileChange}
                />
              </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3 mt-3">
                    <Form.Label className=" font-weight-bold">
                      Employer/Company Name
                    </Form.Label>
                    <Form.Control
                      name="employer"
                      value={formData.employer}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label className="mt-3 font-weight-bold">
                      Designation
                    </Form.Label>
                    <Form.Control
                      name="designation"
                      value={formData.designation}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label className="font-weight-bold">
                      Years of Experience
                    </Form.Label>
                    <Form.Select
                      name="yearsOfExperience"
                      value={formData.yearsOfExperience}
                      onChange={handleChange}
                    >
                      <option value="">Select</option>
                      <option value="0">0</option>
                      {Array.from({ length: 60 }, (_, i) => i + 1).map(
                        (year) => (
                          <option key={year} value={year}>
                            {year}
                          </option>
                        )
                      )}
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label className="font-weight-bold">
                      Months of Experience
                    </Form.Label>
                    <Form.Select
                      name="monthsOfExperience"
                      value={formData.monthsOfExperience}
                      onChange={handleChange}
                    >
                      <option value="">Select</option>
                      <option value="0">0</option>
                      {Array.from({ length: 12 }, (_, i) => i + 1).map(
                        (month) => (
                          <option key={month} value={month}>
                            {month}
                          </option>
                        )
                      )}
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label className="font-weight-bold">
                      Current CTC
                    </Form.Label>
                    <Form.Control
                      name="currentCTC"
                      value={formData.currentCTC}
                     onChange={(e) => {
                        const value = e.target.value;
                        if (/^\d{0,12}$/.test(value)) {
                          handleChange(e); // update state only if valid
                        }
                      }}
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label className="font-weight-bold">
                      Expected CTC
                    </Form.Label>
                    <Form.Control
                      name="expectedCTC"
                      value={formData.expectedCTC}
                     onChange={(e) => {
                        const value = e.target.value;
                        if (/^\d{0,12}$/.test(value)) {
                          handleChange(e); // update state only if valid
                        }
                      }}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md={12}>
                  <Form.Group className="mb-3">
                    <Form.Label className="font-weight-bold">
                      How Did You Hear About Us?
                    </Form.Label>
                    <Form.Select
                      name="source"
                      value={formData.source}
                      onChange={handleChange}
                    >
                      <option value="">Select Source</option>
                      {sourceOptions.map((option, index) => (
                        <option key={index} value={option}>
                          {option}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label className="font-weight-bold">
                      Residential Address
                    </Form.Label>
                    <Form.Control
                      name="residentialAddress"
                      value={formData.residentialAddress}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label className="font-weight-bold">
                      Residential City
                    </Form.Label>
                    <Form.Control
                      name="residentialCity"
                      value={formData.residentialCity}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label className="font-weight-bold">
                      Mailing Address
                    </Form.Label>
                    <Form.Control
                      name="mailingAddress"
                      value={formData.mailingAddress}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label className="font-weight-bold">
                      Mailing City
                    </Form.Label>
                    <Form.Control
                      name="mailingCity"
                      value={formData.mailingCity}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md={12}>
                  <Form.Group className="mb-3">
                    <p>
                      <em>
                        By submitting this form, you confirm that you understand
                        and agree to the above terms.
                      </em>
                    </p>
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md={12}>
                  <Form.Group className="mb-3">
                    <Form.Check
                      required
                      name="terms"
                      label={
                        <>
                          I hereby declare that the information provided is true
                          and correct. I accept the{" "}
                          <a href="#important-note" rel="noopener noreferrer">
                            Terms & Conditions
                          </a>
                        </>
                      }
                      feedback="You must agree before submitting."
                      feedbackType="invalid"
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Button variant="primary" type="submit">
                Submit
              </Button>
            </Form>
          </Card.Body>
        </Card>

        <Card className="mb-4 mt-2 shadow" id="important-note">
          <Card.Body>
            <Card.Title className="text-dark fs-4">
              Important Note (Please Read Before Filling the Form)-
            </Card.Title>
            <Card.Text className="text-secondary">
              This registration form is issued by{" "}
              <strong>Employment Mantras</strong> for the sole purpose of
              candidate data collection and internal record maintenance.
            </Card.Text>

            <ul>
              <li className="text-secondary">
                Filling this form does not guarantee job placement or
                employment.
              </li>
              <li className="text-secondary">
                The information provided will be used strictly for shortlisting
                and communication related to suitable job opportunities.
              </li>
            </ul>

            <Card.Title className="text-dark fs-5 mt-4">
              Data Privacy Disclaimer-
            </Card.Title>
            <Card.Text className="text-secondary">
              All personal details shared in this form will be kept{" "}
              <strong>confidential</strong> and used only for
              recruitment-related purposes. <strong>Employment Mantras</strong>{" "}
              is committed to protecting your data and will not share it with
              any third party without your consent.
            </Card.Text>
          </Card.Body>
        </Card>

        <Link
          className="nav-link collapsed rounded-pill mx-2 text-center"
          href="#"
          onClick={() => window.open("https://techtorch.solutions/")}
        >
          <span class="badge text-bg-light  fw-lighter opacity-75">
            Powered By{" "}
            <img
              src={brandLogo}
              className="img-fluid "
              alt="logo"
              width="70px"
            />
          </span>
        </Link>
      </Container>
    </div>
  );
};

export default CandRegOpenLink;
